const NAME = "SCHEDULES_DEFINITION";

export default NAME;
